var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3 118 629.1700134277344 301.4661407470703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSerif: "http://www.serif.com/",
    viewBox: "0.0002892613410949707 0 57.39071273803711 68.57699584960938",
    xmlSpace: "preserve",
    height: 161.4661407470703,
    width: 135.12775310217177,
    y: 188,
    x: 73,
    preserveAspectRatio: "xMinYMin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.485,27.589c0.916,0 1.66,0.744 1.66,1.66c-0,0.917 -0.744,1.66 -1.66,1.66l-1.787,0l-0,11.906l12.896,20.685c0.638,1.024 0.671,2.313 0.086,3.368c-0.586,1.055 -1.697,1.709 -2.903,1.709l-35.457,0c-1.206,0 -2.318,-0.654 -2.903,-1.709c-0.585,-1.055 -0.552,-2.344 0.086,-3.368c-0,0 12.896,-20.685 12.896,-20.685l0,-11.906l-2.224,0c-0.916,0 -1.66,-0.743 -1.66,-1.66c-0,-0.916 0.744,-1.66 1.66,-1.66l5.544,0l0,16.176l-13.399,21.492l35.457,-0l-13.4,-21.492l0,-16.176l5.108,0Z",
    style: {
      fill: "#171d4e",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.796,
    cy: 61.528,
    r: 2.579,
    style: {
      fill: "#ff0023"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.043,
    cy: 56.28,
    r: 3.508,
    style: {
      fill: "#00a8ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.163,
    cy: 62.397,
    r: 1.529,
    style: {
      fill: "#ff00eb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.942,
    cy: 50.224,
    r: 1.649,
    style: {
      fill: "#04a9c6",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.106,
    cy: 60.268,
    r: 3.418,
    style: {
      fill: "#0200ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.84,
    cy: 61.438,
    r: 1.949,
    style: {
      fill: "#8f00ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.689,
    cy: 55.771,
    r: 2.998,
    style: {
      fill: "#0065ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.888,
    cy: 61.408,
    r: 0.959,
    style: {
      fill: "#7800ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.966,
    cy: 54.811,
    r: 1.439,
    style: {
      fill: "#00c5ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.519,
    cy: 49.564,
    r: 2.429,
    style: {
      fill: "#01ab83",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.72,
    cy: 44.047,
    r: 1.829,
    style: {
      fill: "#05ab26",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.75,
    cy: 38.2,
    r: 2.219,
    style: {
      fill: "#49ab03",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.04,
    cy: 32.113,
    r: 1.289,
    style: {
      fill: "#83c606",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.741,
    cy: 25.756,
    r: 1.769,
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.328,
    cy: 21.948,
    r: 2.639,
    style: {
      fill: "#ff8c00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.956,
    cy: 11.184,
    r: 2.908,
    style: {
      fill: "#8f00ff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.204,
    cy: 17.751,
    r: 2.039,
    style: {
      fill: "#ff0023",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.381,
    cy: 12.174,
    r: 3.178,
    style: {
      fill: "#5e00ff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.636,
    cy: 15.832,
    r: 2.279,
    style: {
      fill: "#ff00ed",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.472,
    cy: 1.919,
    r: 1.919,
    style: {
      fill: "#90f",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.417,
    cy: 6.177,
    r: 2.938,
    style: {
      fill: "#5e00ff",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("svg", _extends({
    y: 267.80000175476073,
    viewBox: "1.590000033378601 13.220000267028809 385.1700134277344 39.39999771118164",
    x: 177,
    height: 39.39999771118164,
    width: 385.1700134277344,
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#171d4e",
    fillOpacity: 1,
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59 17.49L27.03 17.49L27.03 23.11L17.79 23.11L17.79 52.18L10.83 52.18L10.83 23.11L1.59 23.11L1.59 17.49ZM47.61 24.25Q50.74 24.25 53.17 25.62Q55.61 26.98 56.97 29.64Q58.34 32.30 58.34 36.03L58.34 36.03L58.34 52.18L51.38 52.18L51.38 36.97Q51.38 33.69 49.74 31.93Q48.10 30.16 45.27 30.16L45.27 30.16Q42.39 30.16 40.72 31.93Q39.06 33.69 39.06 36.97L39.06 36.97L39.06 52.18L32.10 52.18L32.10 15.40L39.06 15.40L39.06 28.08Q40.40 26.29 42.64 25.27Q44.87 24.25 47.61 24.25L47.61 24.25ZM90.54 37.82Q90.54 39.31 90.34 40.50L90.34 40.50L70.22 40.50Q70.46 43.48 72.30 45.17Q74.14 46.86 76.83 46.86L76.83 46.86Q80.70 46.86 82.34 43.53L82.34 43.53L89.85 43.53Q88.65 47.51 85.27 50.07Q81.89 52.62 76.97 52.62L76.97 52.62Q73.00 52.62 69.84 50.86Q66.69 49.10 64.92 45.87Q63.16 42.64 63.16 38.41L63.16 38.41Q63.16 34.14 64.90 30.91Q66.64 27.68 69.77 25.94Q72.90 24.20 76.97 24.20L76.97 24.20Q80.90 24.20 84.01 25.89Q87.11 27.58 88.83 30.69Q90.54 33.79 90.54 37.82L90.54 37.82ZM70.27 35.83L83.34 35.83Q83.29 33.15 81.40 31.53Q79.51 29.92 76.78 29.92L76.78 29.92Q74.19 29.92 72.43 31.48Q70.66 33.05 70.27 35.83L70.27 35.83ZM130.99 52.18L128.70 45.57L114.89 45.57L112.60 52.18L105.30 52.18L117.77 17.44L125.87 17.44L138.35 52.18L130.99 52.18ZM116.78 40.00L126.82 40.00L121.80 25.49L116.78 40.00ZM149.97 28.92Q151.32 26.73 153.48 25.49Q155.64 24.25 158.42 24.25L158.42 24.25L158.42 31.56L156.58 31.56Q153.30 31.56 151.64 33.10Q149.97 34.64 149.97 38.46L149.97 38.46L149.97 52.18L143.02 52.18L143.02 24.65L149.97 24.65L149.97 28.92ZM177.35 30.36L171.19 30.36L171.19 43.68Q171.19 45.07 171.86 45.69Q172.53 46.31 174.12 46.31L174.12 46.31L177.35 46.31L177.35 52.18L172.98 52.18Q164.19 52.18 164.19 43.63L164.19 43.63L164.19 30.36L160.91 30.36L160.91 24.65L164.19 24.65L164.19 17.84L171.19 17.84L171.19 24.65L177.35 24.65L177.35 30.36ZM185.90 21.37Q184.06 21.37 182.85 20.20Q181.63 19.03 181.63 17.29L181.63 17.29Q181.63 15.55 182.85 14.39Q184.06 13.22 185.90 13.22L185.90 13.22Q187.74 13.22 188.96 14.39Q190.18 15.55 190.18 17.29L190.18 17.29Q190.18 19.03 188.96 20.20Q187.74 21.37 185.90 21.37L185.90 21.37ZM182.37 24.65L189.33 24.65L189.33 52.18L182.37 52.18L182.37 24.65ZM206.72 52.62Q203.34 52.62 200.66 51.41Q197.98 50.19 196.41 48.10Q194.85 46.02 194.70 43.48L194.70 43.48L201.70 43.48Q201.90 45.07 203.27 46.12Q204.64 47.16 206.67 47.16L206.67 47.16Q208.66 47.16 209.78 46.36Q210.90 45.57 210.90 44.33L210.90 44.33Q210.90 42.98 209.53 42.31Q208.16 41.64 205.18 40.85L205.18 40.85Q202.10 40.10 200.14 39.31Q198.18 38.51 196.76 36.87Q195.34 35.23 195.34 32.45L195.34 32.45Q195.34 30.16 196.66 28.28Q197.98 26.39 200.44 25.29Q202.90 24.20 206.23 24.20L206.23 24.20Q211.15 24.20 214.08 26.66Q217.01 29.12 217.31 33.29L217.31 33.29L210.65 33.29Q210.50 31.65 209.28 30.69Q208.06 29.72 206.03 29.72L206.03 29.72Q204.14 29.72 203.12 30.41Q202.10 31.11 202.10 32.35L202.10 32.35Q202.10 33.74 203.49 34.46Q204.88 35.18 207.82 35.93L207.82 35.93Q210.80 36.67 212.74 37.47Q214.67 38.26 216.09 39.93Q217.51 41.59 217.56 44.33L217.56 44.33Q217.56 46.71 216.24 48.60Q214.92 50.49 212.46 51.56Q210.00 52.62 206.72 52.62L206.72 52.62ZM221.48 38.31Q221.48 34.14 223.15 30.91Q224.81 27.68 227.67 25.94Q230.53 24.20 234.05 24.20L234.05 24.20Q237.14 24.20 239.45 25.44Q241.76 26.69 243.15 28.57L243.15 28.57L243.15 24.65L250.15 24.65L250.15 52.18L243.15 52.18L243.15 48.15Q241.81 50.09 239.45 51.36Q237.09 52.62 234.00 52.62L234.00 52.62Q230.53 52.62 227.67 50.84Q224.81 49.05 223.15 45.79Q221.48 42.54 221.48 38.31L221.48 38.31ZM243.15 38.41Q243.15 35.88 242.15 34.06Q241.16 32.25 239.47 31.28Q237.78 30.31 235.84 30.31L235.84 30.31Q233.91 30.31 232.27 31.26Q230.63 32.20 229.61 34.01Q228.59 35.83 228.59 38.31L228.59 38.31Q228.59 40.80 229.61 42.66Q230.63 44.52 232.29 45.52Q233.95 46.51 235.84 46.51L235.84 46.51Q237.78 46.51 239.47 45.54Q241.16 44.57 242.15 42.76Q243.15 40.95 243.15 38.41L243.15 38.41ZM272.22 24.25Q277.14 24.25 280.17 27.36Q283.20 30.46 283.20 36.03L283.20 36.03L283.20 52.18L276.24 52.18L276.24 36.97Q276.24 33.69 274.60 31.93Q272.96 30.16 270.13 30.16L270.13 30.16Q267.25 30.16 265.58 31.93Q263.92 33.69 263.92 36.97L263.92 36.97L263.92 52.18L256.96 52.18L256.96 24.65L263.92 24.65L263.92 28.08Q265.31 26.29 267.47 25.27Q269.63 24.25 272.22 24.25L272.22 24.25ZM308.59 17.49L308.59 46.66L320.02 46.66L320.02 52.18L301.64 52.18L301.64 17.49L308.59 17.49ZM322.66 38.31Q322.66 34.14 324.32 30.91Q325.99 27.68 328.84 25.94Q331.70 24.20 335.23 24.20L335.23 24.20Q338.31 24.20 340.62 25.44Q342.93 26.69 344.32 28.57L344.32 28.57L344.32 24.65L351.33 24.65L351.33 52.18L344.32 52.18L344.32 48.15Q342.98 50.09 340.62 51.36Q338.26 52.62 335.18 52.62L335.18 52.62Q331.70 52.62 328.84 50.84Q325.99 49.05 324.32 45.79Q322.66 42.54 322.66 38.31L322.66 38.31ZM344.32 38.41Q344.32 35.88 343.33 34.06Q342.34 32.25 340.65 31.28Q338.96 30.31 337.02 30.31L337.02 30.31Q335.08 30.31 333.44 31.26Q331.80 32.20 330.78 34.01Q329.76 35.83 329.76 38.31L329.76 38.31Q329.76 40.80 330.78 42.66Q331.80 44.52 333.47 45.52Q335.13 46.51 337.02 46.51L337.02 46.51Q338.96 46.51 340.65 45.54Q342.34 44.57 343.33 42.76Q344.32 40.95 344.32 38.41L344.32 38.41ZM365.09 28.67Q366.44 26.69 368.80 25.44Q371.16 24.20 374.19 24.20L374.19 24.20Q377.72 24.20 380.57 25.94Q383.43 27.68 385.10 30.88Q386.76 34.09 386.76 38.31L386.76 38.31Q386.76 42.54 385.10 45.79Q383.43 49.05 380.57 50.84Q377.72 52.62 374.19 52.62L374.19 52.62Q371.11 52.62 368.80 51.41Q366.49 50.19 365.09 48.25L365.09 48.25L365.09 52.18L358.14 52.18L358.14 15.40L365.09 15.40L365.09 28.67ZM379.65 38.31Q379.65 35.83 378.64 34.01Q377.62 32.20 375.95 31.26Q374.29 30.31 372.35 30.31L372.35 30.31Q370.46 30.31 368.80 31.28Q367.13 32.25 366.11 34.09Q365.09 35.93 365.09 38.41L365.09 38.41Q365.09 40.90 366.11 42.74Q367.13 44.57 368.80 45.54Q370.46 46.51 372.35 46.51L372.35 46.51Q374.29 46.51 375.95 45.52Q377.62 44.52 378.64 42.69Q379.65 40.85 379.65 38.31L379.65 38.31Z",
    transform: "translate(0, 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.71c04c59e36ddc351c6f92ef4338489d.svg";
export { ForwardRef as ReactComponent };